module.exports = __webpack_public_path__ + "static/basket-56bd02b2d210efd4d4d515b0677dc859.png";